import { render, staticRenderFns } from "./theme3.vue?vue&type=template&id=7f24576b&"
import script from "./theme3.vue?vue&type=script&lang=ts&"
export * from "./theme3.vue?vue&type=script&lang=ts&"
import style0 from "./theme3.vue?vue&type=style&index=0&id=7f24576b&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports